import { GlobalClassInstance } from "@commoncore/constants/GlobalClass";
import { FileOperationsImplementation } from "@commoncore/implementation/FileOperationsImplementation";
import { JioPhoneCallImplementation } from "@commoncore/implementation/JioPhoneCallImplementation";
import { GlobalService } from "@commoncore/services/global.service";
import { AppEvents } from "@commoncore/utils/app-events";
import { ENV_CONSTANTS } from "@env-properties/environment";
import { ENV_CONFIG } from "@env-properties/environment-config";
import { SHARE_DC } from "@mainrepo/app/core/constants/ShareDCURLs";
import { Controller } from "./Controller";

export class JioPhoneCallController extends Controller{
    public universalService:any;
    public router:any;
    public http:any;
    public static singleInstance:any = null;
    jioPhoneCallImpl: any;
    fileOperationsImplementation: any;
    sessionStorageService:any;


    public constructor(public globalService:GlobalService) {
      super(globalService);
      this.setEnvObjects(globalService)
    }

    setEnvObjects(globalService){
      this.jioPhoneCallImpl =  JioPhoneCallImplementation.getInstance(globalService);
      this.fileOperationsImplementation = FileOperationsImplementation.getInstance(globalService);
      this.universalService = globalService.getUniversalServiceRef();
      this.sessionStorageService = globalService.getSessionStorageSvcRef();
    }
    
    public static getInstance(globalService):JioPhoneCallController{
      if(this.singleInstance == null){
        this.singleInstance = new JioPhoneCallController(globalService);
        return this.singleInstance;
      }else{
        return this.singleInstance;
      }
    }

    async updateRecordingToggle(updateStatus){
      this.jioPhoneCallImpl.setHandler(this.globalService);
      let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["securityURL"]  + ENV_CONFIG.commonUrls["userFeture"] 
      try{
        var result = await this.jioPhoneCallImpl.updateRecordingToggle(url,updateStatus);
        return result
      }catch(exc){
        console.log("exception in fetching selected face details",exc);
        return exc;
      }
    }

    async getAllLinkedApps() {
      this.jioPhoneCallImpl.setHandler(this.globalService);
      let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["nmsHeadlessLinkedAppsApi"];
      try{
        var result = await this.jioPhoneCallImpl.getAllLinkedApps(url);
        return result
      }catch(exc){
        console.log("exception in getAllLinkedApps details : ",exc);
        return exc;
      }
    }

    async getAllJioPhoneCallRecordingMetadata(folderKey) {
      let currentFolderKey = this.sessionStorageService.getCurrentFolderkey(true);
      currentFolderKey = currentFolderKey ? currentFolderKey : this.jioPhoneCallImpl.jioPhoneCallAppFolderKey;
      if(!folderKey){
        folderKey = currentFolderKey ? currentFolderKey : this.jioPhoneCallImpl.jioPhoneCallAppFolderKey;
      }
      this.universalService.openFolderContent = currentFolderKey && currentFolderKey != this.jioPhoneCallImpl.jioPhoneCallAppFolderKey? true: false;
      let limit = ENV_CONFIG["constants"]["PAGE_LIMIT"] * ENV_CONFIG["constants"]["PAGINATION_BUFFER"];
      this.jioPhoneCallImpl.setHandler(this.globalService);
      let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["nmsHeadlessLinkedAppApi"] + ENV_CONFIG.commonUrls["metaData"] + "?appcode=" + this.jioPhoneCallImpl.jioPhoneCallAppCode + "&folderKey=" + folderKey + "&limit="+ limit;
      try{
        var result = await this.jioPhoneCallImpl.getAllJioPhoneCallRecordingMetadata(url, !this.universalService.openFolderContent);
        console.log("Folders:",result);
        return result
      }catch(exc){
        console.log("exception in getAllJioPhoneCallRecordingMetadata details : ",exc);
        return exc;
      }
    }

    async getSMSLinkDC(smsKey){
      this.jioPhoneCallImpl.setHandler(this.globalService);
      let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["nmsHeadlessLinkedAppApi"] + ENV_CONFIG.commonUrls["getSMSLinkDC"] + "/" + smsKey;
      try{
        var result = await this.jioPhoneCallImpl.getSMSLinkDC(url);
        console.log("getSMSLinkDC",result);
        return result
      }catch(exc){
        console.log("exception in getSMSLinkDC : ",exc);
        return exc;
      }
    }  

    async getSMSLinkMetadata(smsKey){
      this.jioPhoneCallImpl.setHandler(this.globalService);
      let url = SHARE_DC["DC_URLS"]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["nmsHeadlessLinkedAppApi"] + ENV_CONFIG.commonUrls["metaData"] + "/" + smsKey;
      try{
        var result = await this.jioPhoneCallImpl.getSMSLinkMetadata(url);
        console.log("folder linked to smskey:",result);
        return result
      }catch(exc){
        console.log("exception in getSMSLinkMetadata : ",exc);
        return exc;
      }
    }

    onScrollDown(docheignt,toppos){
      let self = this;      
      var url = "";
      url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] +  self.jioPhoneCallImpl.jioPhoneCallNextLink;
      try{
        self.jioPhoneCallImpl.createUrlForNextLink(docheignt,toppos,url);
      }
      catch(exc){
       console.log("exception in scroll down")
      }
  }

  async updateUIAfterPerformingAction(list,executedTask){
    var array = this.jioPhoneCallImpl.jioPhoneCallObjects;
    if(executedTask == 'TRASH'){
      this.fileOperationsImplementation.setHandler(this.globalService);
      var result = await this.fileOperationsImplementation.updateOnlyTheUIWithoutMonthWiseSegregation(array,list,executedTask);
      array = result;
      if(this.universalService.virtualGridEnabled){
        AppEvents.virtualDOMObservable.next({"updateVDOM":true,"removeObjects":true,objectsList:list})
      }
    }else{
        console.log("task invalid",executedTask)
    }
    if(array.length == 0 && this.universalService.foldersArray.length == 0){
      return "empty"
    }else{
      return ""
    }
  }

  getNextPageData(){
    this.getAllJioPhoneCallRecordingMetadata(null);
  }

    
}